import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=11c87b74&"
import script from "./JobDetails.vue?vue&type=script&lang=ts&"
export * from "./JobDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports